import React from 'react'
import {BoxProps, useMultiStyleConfig, Text, VStack} from '@chakra-ui/react'
import {useIntl} from 'react-intl'

/**
 * @name ContactUsTitle
 *
 * @component
 *
 * @description
 * Renders the title of the product contact us drawer.
 *
 * @returns {React.FC} - The rendered title component.
 */
const ContactUsTitle: React.FC = () => {
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('ProductContactUs', {}) as Record<string, BoxProps>

    const DRAWER_TITLE = formatMessage({id: 'label.contact.form.title', defaultMessage: 'Write your message here'})
    return (
        <VStack {...styles.drawerHeaderWrapper}>
            <Text {...styles.drawerTitle} as={'h2'}>
                {DRAWER_TITLE}
            </Text>
        </VStack>
    )
}

export default ContactUsTitle
